/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class CameraTrackingEvent extends alm.event.Event {

		public static CHANGE:string = "CameraTrackingEvent.CHANGE";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, isTracking:boolean) {
			super(eventType, target);
			this.isTracking = isTracking;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsTracking():boolean {
			return this.isTracking;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isTracking:boolean;
	}
}
